/**
 * CMS Maintenance model
 * NOTE: ACF is active custom fields plugin from WordPress CMS
 */
export class Maintenance {
  constructor(
    public content: string,
    public modifiedDate: Date,
    public display_notification: boolean,
    public enable_downtime: boolean
  ) {}
}
